"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AdmissionArea = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19,4 C19.5522847,4 20,4.44771525 20,5 L20,19 C20,19.5522847 19.5522847,20 19,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,5 C4,4.44771525 4.44771525,4 5,4 L19,4 Z M19,5 L5,5 L5,19 L19,19 L19,5 Z M12.4802884,8.35820058 L14.970871,15.3318318 C15.1924133,15.9300232 14.2858124,16.2715759 14.029129,15.6681682 L13.6737671,14.6826021 L13.4328638,13.999541 L10.5668638,13.999541 L9.97087096,15.6681682 C9.72677612,16.2878876 8.80741882,15.9525909 9.02912904,15.3318318 L11.5197116,8.35820058 C11.6870117,7.89816284 12.2553101,7.89816284 12.4802884,8.35820058 Z M12,9.98660687 L10.9238638,12.999541 L13.0758638,12.999541 L12,9.98660687 Z" })));
};
AdmissionArea.displayName = 'AdmissionArea';
exports.default = AdmissionArea;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AdmissionArea.js.map